export enum AudioNotificationType {
  ExternalTask = 'ExternalTask',
  InstantMessage = 'InstantMessage',
  Email = 'Email',
}
